export { BatteryFullIcon } from './battery-full'
